export default __webpack_public_path__ + "static/EzyMedical ENG - Mobile Banner (EDP)-ef8d1b525466418a4f3e8d208d9b4aa8.png";